import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import { B2, B5, H5 } from '@zet/design-system/typography'

import { brandsI18n } from '../../localization'
import { getTimeRemaining } from '../../utils/time'
import { Note } from '../../utils/types'

type InfoProps = {
  note: Note
  expiryTimeEpochInMillis?: number
}

const Info: React.FC<InfoProps> = ({ note, expiryTimeEpochInMillis }) => {
  const bgClass = note?.type === 'error' ? 'bg-error-10' : 'bg-warning-10'

  const pendingTime = expiryTimeEpochInMillis
    ? getTimeRemaining(expiryTimeEpochInMillis)
    : ''

  return (
    <Stack
      className={
        'my-4/2 px-4/2 mx-3 flex-row items-center rounded-md py-2 ' + bgClass
      }
    >
      <XStack className="items-center">
        <Icon
          type={note?.icon || 'CautionOutlined'}
          color={
            note?.type === 'error'
              ? zetColors.error[100]
              : zetColors.warning[100]
          }
          size={28}
          className="mr-2"
        />
        {note?.title ? (
          <H5>{note?.title}</H5>
        ) : note?.text || note?.localizationText ? (
          <B5 className="text-justify leading-normal">
            {note?.text ??
              brandsI18n.t(note?.localizationText, {
                time: pendingTime,
              })}
          </B5>
        ) : (
          <></>
        )}
      </XStack>
      {note?.description && <B2 className="mt-2">{note?.description}</B2>}
    </Stack>
  )
}

export default Info
